<template>
  <div class="ws-state-checkbox">
    <v-checkbox
      v-for="(item,itemIndex) in items"
      :key="itemIndex"
      :label="item.text"
      :disabled="disabled"
      :inputValue="$_value(item)"
      @change="$_input($event,item)"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  methods: {
    $_value(item) {
      if (this.value) {
        let _checkbox = true;
        item.value.forEach((item) => {
          let _index = this.value.findIndex((value) => value == item);
          if (_index < 0) {
            _checkbox = false;
          }
        });
        return _checkbox;
      } else {
        return false;
      }
    },
    $_input($event, item) {
      if ($event) {
        let _value = this.$_deleteDuplicateValue([
          ...(this.value || []),
          ...item.value,
        ]);
        this.$emit("input", _value);
      } else {
        let _value = this.$_deleteValue(item.value);
        this.$emit("input", _value);
      }
    },
    $_deleteDuplicateValue(value) {
      const _value = value.filter((item, index, arr) => {
        return index == arr.findIndex((findItem) => findItem === item);
      });
      return _value;
    },
    $_deleteValue(value) {
      const _value = this.value.filter((filterItem) => {
        return value.findIndex((findItem) => findItem == filterItem) < 0;
      });
      return _value;
    },
    $_getDefaultValue() {
      if (this.defaultValue !== null && this.value === null) {
        this.$emit("input", this.defaultValue);
      }
    },
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$_getDefaultValue();
  },
};
</script>

<style lang="scss">
  @import "../assets/scss/ws-state-checkbox.scss";
</style>